<div class="d-flex flex-column bg-white px-4 pt-5 pb-3">
    <span class="w-100 text-main text-start fs-21 fw-bold text-center mb-5" style="color: #65bc47;">
        {{ 'OfferPage.EnterAmount' | translate}}
    </span>
    <div class="d-flex align-items-center w-100 pb-1 mt-2 px-4 l-149" style="text-align: start; margin-inline-start: 1.5rem;">
        <div class="d-flex flex-column text-black fs-14 mx-auto w-100">
            <!-- Modify amount input-->
            <div class="mt-6 mx-auto w-100" style="max-width: 350px;">
                <app-currency-input currency="SAR" [max]="offerDetails?.MaxPrincipal" [min]="offerDetails?.MinPrincipal" [(Amount)]="amount" (AmountChange)="validationCheck()"/>
            </div>
        </div>
    </div>
</div>

<!-- Amount Modify buttons - Next/Cancel -->
<div class="d-flex w-100 align-items-center justify-content-around col-12 col-lg-8 mx-auto">
    <button class="cet-btn-primary my-3" style="width: 43%; max-width: 180px;" (click)="modifyAmount()" [disabled]="amount == 0">
        <span>{{ "Buttons.Next" | translate }}</span>
    </button>

    <button (click)="cancelModifyClick()" class="cet-button-outline my-3" style="width: 43%; max-width: 180px;">
        <span>{{ "Buttons.Cancel" | translate }}</span>
    </button>
</div>